import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../constants/labels/en.json';
import fr from '../constants/labels/fr.json';
import env from '../env';

// Add additional languages here
const resources = {
  en: { translation: en },
  fr: { translation: fr },
};

const isFrenchEnabled = env.REACT_APP_ENABLE_LNG === true;
const supportedLanguages = isFrenchEnabled ? ['en', 'fr'] : ['en'];
const storedLanguage =
  typeof window !== 'undefined'
    ? localStorage.getItem('i18nextLng')?.slice(0, 2)?.toLowerCase()
    : null;
const defaultLng =
  isFrenchEnabled && storedLanguage === 'fr' ? 'fr' : 'en';

if (typeof window !== 'undefined') {
  localStorage.setItem('i18nextLng', defaultLng);
}

if (initReactI18next) {
  i18n.use(initReactI18next).init({
    resources,
    lng: defaultLng,
    fallbackLng: 'en',
    supportedLngs: supportedLanguages,
    interpolation: { escapeValue: false },
    keySeparator: false,
  });
} else {
  // In some test environments `react-i18next` may be mocked without
  // `initReactI18next`. Fall back to direct initialization to avoid
  // passing undefined to `i18n.use()`.
  i18n.init({
    resources,
    lng: defaultLng,
    fallbackLng: 'en',
    supportedLngs: supportedLanguages,
    interpolation: { escapeValue: false },
    keySeparator: false,
  });
}

export default i18n;
